import React, { useState, useEffect } from 'react';
import BonsCommandePanel from './BonsCommandePanel';

const API = process.env.REACT_APP_API_URL || 'https://surabaya-api.onrender.com';
const PASSWORD = 'surabaya2026';

async function getToken() {
  const res = await fetch(`${API}/api/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password: PASSWORD })
  });
  const data = await res.json();
  return data.token;
}

export default function StockModule() {
  const [auth, setAuth] = useState(false);
  const [pwd, setPwd] = useState('');
  const [composants, setComposants] = useState([]);
  const [employes, setEmployes] = useState([]);
  const [stockDuJour, setStockDuJour] = useState([]);
  const [dispo, setDispo] = useState([]);
  const [form, setForm] = useState({
    composant_id: '', portions_produites: '', produit_par: 'Christian',
    notes: '', mode_conservation: 'frigo', emplacement: ''
  });
  const [editItem, setEditItem] = useState(null);
  const [editComp, setEditComp] = useState(null);
  const [newComp, setNewComp] = useState(null);
  const [tab, setTab] = useState('saisie');
  const [saisonActuelle, setSaisonActuelle] = useState('ete');
  const [stockStatus, setStockStatus] = useState(null);
  const [loadingSaison, setLoadingSaison] = useState(false);

  async function loadStockStatus() {
    try {
      const token = await getToken();
      const res = await fetch(`${API}/api/admin/stock-status`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.ok) {
        // Filtre côté client : on ne garde que les boissons
        const filtered = data.items.filter(i => i.categorie === 'boissons');
        const filteredStats = {
          total: filtered.length,
          ok: filtered.filter(i => i.statut === 'ok').length,
          alerte: filtered.filter(i => i.statut === 'alerte').length,
          critique: filtered.filter(i => i.statut === 'critique').length
        };
        setStockStatus({ ...data, items: filtered, stats: filteredStats });
        setSaisonActuelle(data.saison);
      }
    } catch (e) {
      console.error('Erreur chargement stock-status:', e);
    }
  }

  async function changerSaison(nouvelleSaison) {
    setLoadingSaison(true);
    try {
      const token = await getToken();
      const res = await fetch(`${API}/api/admin/saison`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ saison: nouvelleSaison })
      });
      const data = await res.json();
      if (data.ok) {
        setSaisonActuelle(data.saison);
        await loadStockStatus();
      }
    } catch (e) {
      console.error('Erreur changement saison:', e);
    } finally {
      setLoadingSaison(false);
    }
  }

  useEffect(() => {
    if (tab === 'suivi' && auth) loadStockStatus();
    // eslint-disable-next-line
  }, [tab, auth]);
  const [msg, setMsg] = useState('');

  useEffect(() => { if (auth) fetchAll(); }, [auth]);

  const fetchAll = async () => {
    const token = await getToken();
    const headers = { 'Authorization': `Bearer ${token}` };
    const [c, s, d, e] = await Promise.all([
      fetch(`${API}/api/stock/composants`, { headers }).then(r => r.json()),
      fetch(`${API}/api/stock/productions?jours=7`, { headers }).then(r => r.json()),
      fetch(`${API}/api/stock/disponibilite`, { headers }).then(r => r.json()),
      fetch(`${API}/api/haccp/employes`, { headers }).then(r => r.json()).catch(() => []),
    ]);
    setComposants(Array.isArray(c) ? c : []);
    setStockDuJour(Array.isArray(s) ? s : []);
    setDispo(Array.isArray(d) ? d : []);
    setEmployes(Array.isArray(e) && e.length > 0 ? e : [
      { nom: 'Christian' }, { nom: 'Mamat' }, { nom: 'Alicia' }, { nom: 'Coralie' }
    ]);
  };

  const handleComposantChange = (id) => {
    const comp = composants.find(c => c.id === parseInt(id));
    setForm({ ...form, composant_id: id, mode_conservation: comp?.mode_conservation || 'frigo', emplacement: comp?.emplacement_defaut || '' });
  };

  const dlcPreview = () => {
    const comp = composants.find(c => c.id === parseInt(form.composant_id));
    if (!comp) return null;
    const jours = form.mode_conservation === 'congelateur' ? comp.dlc_congelateur_jours : comp.dlc_frigo_jours;
    if (!jours) return null;
    return new Date(Date.now() + jours * 86400000).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
  };

  const handleSubmit = async () => {
    if (!form.composant_id || !form.portions_produites) { setMsg('⚠️ Composant et quantité obligatoires'); return; }
    const token = await getToken();
    const res = await fetch(`${API}/api/stock/productions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(form),
    });
    if (res.ok) {
      setMsg('✅ Production enregistrée !');
      setForm({ composant_id: '', portions_produites: '', produit_par: 'Christian', notes: '', mode_conservation: 'frigo', emplacement: '' });
      fetchAll();
    } else setMsg('❌ Erreur lors de l\'enregistrement');
    setTimeout(() => setMsg(''), 3000);
  };

  const handleEdit = async () => {
    if (!editItem) return;
    const token = await getToken();
    const res = await fetch(`${API}/api/stock/productions/${editItem.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({ portions_produites: editItem.portions_produites, notes: editItem.notes, emplacement: editItem.emplacement, mode_conservation: editItem.mode_conservation }),
    });
    if (res.ok) { setMsg('✅ Modifié !'); setEditItem(null); fetchAll(); } else setMsg('❌ Erreur modification');
    setTimeout(() => setMsg(''), 3000);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer cette entrée ?')) return;
    const token = await getToken();
    await fetch(`${API}/api/stock/productions/${id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
    fetchAll();
  };

  const handleSaveComp = async () => {
    if (!editComp) return;
    const token = await getToken();
    const res = await fetch(`${API}/api/stock/composants/${editComp.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({ dlc_frigo_jours: editComp.dlc_frigo_jours, dlc_congelateur_jours: editComp.dlc_congelateur_jours, emplacement_defaut: editComp.emplacement_defaut, mode_conservation: editComp.mode_conservation }),
    });
    if (res.ok) { setMsg('✅ Composant mis à jour !'); setEditComp(null); fetchAll(); } else setMsg('❌ Erreur sauvegarde');
    setTimeout(() => setMsg(''), 3000);
  };

  const handleCreateComp = async () => {
    if (!newComp?.nom) { setMsg('⚠️ Nom obligatoire'); return; }
    const token = await getToken();
    const res = await fetch(`${API}/api/stock/composants`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({ nom: newComp.nom, unite: newComp.unite || 'portion', seuil_alerte: newComp.seuil_alerte || 2 }),
    });
    if (res.ok) { setMsg('✅ Composant créé !'); setNewComp(null); fetchAll(); } else setMsg('❌ Erreur création');
    setTimeout(() => setMsg(''), 3000);
  };

  const dlcColor = (statut) => {
    if (statut === 'expire') return { bg: '#4a1a1a', color: '#f87171', label: '🔴 Expiré' };
    if (statut === 'urgent') return { bg: '#4a2a1a', color: '#fb923c', label: '🟠 Aujourd\'hui' };
    if (statut === 'attention') return { bg: '#3a3a1a', color: '#fbbf24', label: '🟡 Bientôt' };
    return { bg: '#1a3a2a', color: '#4ade80', label: '🟢 OK' };
  };

  if (!auth) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'#1a1a2e' }}>
      <div style={{ background:'#16213e', padding:'40px', borderRadius:'12px', textAlign:'center' }}>
        <h2 style={{ color:'#e94560', marginBottom:'24px' }}>🍽️ Stock Semi-finis</h2>
        <input type="password" placeholder="Mot de passe" value={pwd}
          onChange={e => setPwd(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && pwd === PASSWORD && setAuth(true)}
          style={{ padding:'10px 16px', borderRadius:'8px', border:'1px solid #333', background:'#0f3460', color:'#fff', fontSize:'16px', marginBottom:'12px', display:'block', width:'200px' }}
        />
        <button onClick={() => pwd === PASSWORD && setAuth(true)}
          style={{ background:'#e94560', color:'#fff', border:'none', padding:'10px 24px', borderRadius:'8px', cursor:'pointer', fontSize:'16px' }}>
          Accéder
        </button>
      </div>
    </div>
  );

  const s = {
    container: { fontFamily:'sans-serif', background:'#1a1a2e', minHeight:'100vh', color:'#eee', padding:'20px' },
    card: { background:'#16213e', borderRadius:'12px', padding:'20px', marginBottom:'16px' },
    title: { color:'#e94560', fontSize:'22px', fontWeight:'bold', marginBottom:'20px' },
    tabs: { display:'flex', gap:'8px', marginBottom:'20px', flexWrap:'wrap' },
    tab: (a) => ({ padding:'10px 16px', borderRadius:'8px', cursor:'pointer', border:'none', fontSize:'13px', fontWeight:'bold', background: a ? '#e94560' : '#0f3460', color:'#fff' }),
    label: { display:'block', marginBottom:'6px', color:'#aaa', fontSize:'13px' },
    input: { width:'100%', padding:'10px', borderRadius:'8px', border:'1px solid #333', background:'#0f3460', color:'#fff', fontSize:'15px', marginBottom:'12px', boxSizing:'border-box' },
    select: { width:'100%', padding:'10px', borderRadius:'8px', border:'1px solid #333', background:'#0f3460', color:'#fff', fontSize:'15px', marginBottom:'12px', boxSizing:'border-box' },
    btn: { background:'#e94560', color:'#fff', border:'none', padding:'12px 24px', borderRadius:'8px', cursor:'pointer', fontSize:'15px', fontWeight:'bold' },
    btnSm: (color) => ({ background: color, color:'#fff', border:'none', padding:'4px 10px', borderRadius:'6px', cursor:'pointer', fontSize:'12px', marginLeft:'6px' }),
    table: { width:'100%', borderCollapse:'collapse' },
    th: { textAlign:'left', padding:'10px', color:'#e94560', borderBottom:'1px solid #333', fontSize:'13px' },
    td: { padding:'10px', borderBottom:'1px solid #222', fontSize:'14px', verticalAlign:'middle' },
    infoBox: { background:'#0f3460', borderRadius:'8px', padding:'10px 14px', marginBottom:'12px', fontSize:'13px', color:'#7dd3fc' },
    modal: { position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 },
    modalBox: { background:'#16213e', borderRadius:'12px', padding:'30px', width:'420px', maxWidth:'90vw' },
  };

  return (
    <>
    <div style={s.container} translate="no">
      <div style={s.card}>
        <div style={s.title}>🍽️ Stock Semi-finis — {new Date().toLocaleDateString('fr-FR', { weekday:'long', day:'numeric', month:'long' })}</div>
        <div style={s.tabs}>
          {['saisie','stock','dispo','config','suivi','commandes'].map(t => (
            <button key={t} style={s.tab(tab===t)} onClick={() => setTab(t)}>
              {t==='saisie' ? '✏️ Saisie' : t==='stock' ? '📦 Stock & DLC' : t==='dispo' ? '🍴 Dispo plats' : t==='config' ? '⚙️ Composants de configuration' : t==='suivi' ? '🍺 Boissons & Saison' : '📦 Bons de commande'}
            </button>
          ))}
        </div>

        {tab === 'saisie' && (
          <div>
            <label style={s.label}>Composant préparé</label>
            <select style={s.select} value={form.composant_id} onChange={e => handleComposantChange(e.target.value)}>
              <option value="">-- Choisir un composant --</option>
              {composants.map(c => <option key={c.id} value={c.id}>{c.nom}</option>)}
            </select>
            <label style={s.label}>Nombre de portions produites</label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              style={s.input}
              value={form.portions_produites}
              onChange={e => setForm({...form, portions_produites: e.target.value.replace(/[^0-9]/g, '')})}
              onBlur={e => { if (!e.target.value) setForm(f => ({...f, portions_produites: ''})); }}
              placeholder="ex: 10"
            />
            <label style={s.label}>Mode de conservation</label>
            <select style={s.select} value={form.mode_conservation} onChange={e => setForm({...form, mode_conservation: e.target.value})}>
              <option value="frigo">❄️ Frigo</option>
              <option value="congelateur">🧊 Congélateur</option>
              <option value="ambiant">🌡️ Ambiant</option>
            </select>
            <label style={s.label}>Emplacement</label>
            <input style={s.select} value={form.emplacement}
              onChange={e => setForm({...form, emplacement: e.target.value})} placeholder="ex: frigo 1, bac 3..." />
            {dlcPreview() && <div style={s.infoBox}>📅 DLC calculée : <strong>{dlcPreview()}</strong></div>}
            <label style={s.label}>Préparé par</label>
            <select style={s.select} value={form.produit_par} onChange={e => setForm({...form, produit_par: e.target.value})}>
              {employes.map(e => <option key={e.nom} value={e.nom}>{e.nom}</option>)}
            </select>
            <label style={s.label}>Notes (facultatives)</label>
            <input style={s.input} value={form.notes}
              onChange={e => setForm({...form, notes: e.target.value})} placeholder="ex: pour ce soir" />
            {msg && <div style={{ marginBottom:'12px', color: msg.includes('✅') ? '#4ade80' : '#f87171' }}>{msg}</div>}
            <button style={s.btn} onClick={handleSubmit}>Enregistrer la production</button>
          </div>
        )}

        {tab === 'stock' && (
          <div>
            {msg && <div style={{ marginBottom:'12px', color: msg.includes('✅') ? '#4ade80' : '#f87171' }}>{msg}</div>}
            <table style={s.table}>
              <thead><tr>
                <th style={s.th}>Composant</th><th style={s.th}>Portions</th>
                <th style={s.th}>Emplacement</th><th style={s.th}>DLC</th>
                <th style={s.th}>Statut</th><th style={s.th}>Actions</th>
              </tr></thead>
              <tbody>
                {stockDuJour.length === 0
                  ? <tr><td colSpan={6} style={{...s.td, color:'#666', textAlign:'center'}}>Aucun stock enregistré</td></tr>
                  : stockDuJour.map(item => {
                    const dlc = dlcColor(item.dlc_statut);
                    return (
                      <tr key={item.id}>
                        <td style={s.td}><strong>{item.composant_nom || item.composant_name}</strong></td>
                        <td style={s.td}>{item.portions_produites}</td>
                        <td style={s.td}>{item.emplacement || '—'}</td>
                        <td style={s.td}>{item.dlc_calculee ? new Date(item.dlc_calculee).toLocaleDateString('fr-FR') : '—'}</td>
                        <td style={s.td}><span style={{ padding:'2px 10px', borderRadius:'20px', fontSize:'12px', fontWeight:'bold', background: dlc.bg, color: dlc.color }}>{dlc.label}</span></td>
                        <td style={s.td}>
                          <button style={s.btnSm('#0f3460')} onClick={() => setEditItem({...item})}>✏️</button>
                          <button style={s.btnSm('#7f1d1d')} onClick={() => handleDelete(item.id)}>🗑️</button>
                        </td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
          </div>
        )}

        {tab === 'dispo' && (
          <table style={s.table}>
            <thead><tr>
              <th style={s.th}>Plat</th><th style={s.th}>Portions dispo</th><th style={s.th}>Statut</th>
            </tr></thead>
            <tbody>
              {dispo.map(d => (
                <tr key={d.plat}>
                  <td style={s.td}>{d.plat}</td>
                  <td style={s.td}><strong>{d.portions_dispo ?? '—'}</strong></td>
                  <td style={s.td}>
                    <span style={{ padding:'2px 10px', borderRadius:'20px', fontSize:'12px', fontWeight:'bold',
                      background: d.portions_dispo === null ? '#2a2a2a' : d.portions_dispo === 0 ? '#4a1a1a' : d.portions_dispo <= 2 ? '#3a3a1a' : '#1a3a2a',
                      color: d.portions_dispo === null ? '#888' : d.portions_dispo === 0 ? '#f87171' : d.portions_dispo <= 2 ? '#fbbf24' : '#4ade80'
                    }}>
                      {d.portions_dispo === null ? 'Non suivi' : d.portions_dispo === 0 ? '🔴 Rupture' : d.portions_dispo <= 2 ? '🟡 Attention' : '🟢 OK'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {tab === 'config' && (
          <div>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'12px' }}>
            <div style={s.infoBox}>⚙️ Configure les DLC et emplacements par défaut.</div>
            <button style={{...s.btn, marginLeft:'12px', whiteSpace:'nowrap'}} onClick={() => setNewComp({ nom:'', unite:'portion', seuil_alerte:2 })}>➕ Nouveau composant</button>
          </div>
            {msg && <div style={{ marginBottom:'12px', color: msg.includes('✅') ? '#4ade80' : '#f87171' }}>{msg}</div>}
            <table style={s.table}>
              <thead><tr>
                <th style={s.th}>Composant</th><th style={s.th}>Mode défaut</th>
                <th style={s.th}>DLC frigo (j)</th><th style={s.th}>DLC congélo (j)</th>
                <th style={s.th}>Emplacement défaut</th><th style={s.th}></th>
              </tr></thead>
              <tbody>
                {composants.map(c => (
                  <tr key={c.id}>
                    <td style={s.td}><strong>{c.nom}</strong></td>
                    <td style={s.td}>{c.mode_conservation === 'congelateur' ? '🧊' : c.mode_conservation === 'ambiant' ? '🌡️' : '❄️'} {c.mode_conservation}</td>
                    <td style={s.td}>{c.dlc_frigo_jours ?? '—'} j</td>
                    <td style={s.td}>{c.dlc_congelateur_jours ?? '—'} j</td>
                    <td style={s.td}>{c.emplacement_defaut || '—'}</td>
                    <td style={s.td}><button style={s.btnSm('#0f3460')} onClick={() => setEditComp({...c})}>✏️ Modifier</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {tab === 'suivi' && stockStatus && (
          <div>
            <div style={s.infoBox}>
              📅 Saison active : <strong>{saisonActuelle === 'ete' ? '☀️ Été' : '❄️ Hiver'}</strong>
              {' — '}les seuils d'alerte s'adaptent automatiquement.
            </div>

            <div style={{ display:'flex', gap:'12px', marginBottom:'20px' }}>
              <button
                onClick={() => changerSaison('ete')}
                disabled={loadingSaison || saisonActuelle === 'ete'}
                style={{
                  flex:1, padding:'16px', borderRadius:'10px', border:'none',
                  cursor: loadingSaison ? 'wait' : 'pointer',
                  fontSize:'16px', fontWeight:'bold', color:'#fff',
                  background: saisonActuelle === 'ete' ? '#e94560' : '#0f3460',
                  opacity: loadingSaison ? 0.6 : 1
                }}>
                ☀️ Été {saisonActuelle === 'ete' && '(actif)'}
              </button>
              <button
                onClick={() => changerSaison('hiver')}
                disabled={loadingSaison || saisonActuelle === 'hiver'}
                style={{
                  flex:1, padding:'16px', borderRadius:'10px', border:'none',
                  cursor: loadingSaison ? 'wait' : 'pointer',
                  fontSize:'16px', fontWeight:'bold', color:'#fff',
                  background: saisonActuelle === 'hiver' ? '#e94560' : '#0f3460',
                  opacity: loadingSaison ? 0.6 : 1
                }}>
                ❄️ Hiver {saisonActuelle === 'hiver' && '(actif)'}
              </button>
            </div>

            <div style={{ display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gap:'12px', marginBottom:'20px' }}>
              <div style={{ background:'#0f3460', padding:'14px', borderRadius:'8px', textAlign:'center' }}>
                <div style={{ fontSize:'12px', color:'#aaa' }}>Total</div>
                <div style={{ fontSize:'24px', fontWeight:'bold', color:'#fff' }}>{stockStatus.stats.total}</div>
              </div>
              <div style={{ background:'#16a34a', padding:'14px', borderRadius:'8px', textAlign:'center' }}>
                <div style={{ fontSize:'12px', color:'#dcfce7' }}>OK</div>
                <div style={{ fontSize:'24px', fontWeight:'bold', color:'#fff' }}>{stockStatus.stats.ok}</div>
              </div>
              <div style={{ background:'#f59e0b', padding:'14px', borderRadius:'8px', textAlign:'center' }}>
                <div style={{ fontSize:'12px', color:'#fef3c7' }}>Alerte</div>
                <div style={{ fontSize:'24px', fontWeight:'bold', color:'#fff' }}>{stockStatus.stats.alerte}</div>
              </div>
              <div style={{ background:'#dc2626', padding:'14px', borderRadius:'8px', textAlign:'center' }}>
                <div style={{ fontSize:'12px', color:'#fecaca' }}>Critique</div>
                <div style={{ fontSize:'24px', fontWeight:'bold', color:'#fff' }}>{stockStatus.stats.critique}</div>
              </div>
            </div>

            <table style={s.table}>
              <thead>
                <tr>
                  <th style={s.th}>Composant</th>
                  <th style={s.th}>Stock actuel</th>
                  <th style={s.th}>Seuil ({saisonActuelle})</th>
                  <th style={s.th}>Statut</th>
                  <th style={s.th}>Réappro</th>
                  <th style={s.th}>Fournisseur</th>
                </tr>
              </thead>
              <tbody>
                {stockStatus.items.map(it => {
                  const color = it.statut === 'ok' ? '#16a34a' : it.statut === 'alerte' ? '#f59e0b' : '#dc2626';
                  const label = it.statut === 'ok' ? '✅ OK' : it.statut === 'alerte' ? '⚠️ Alerte' : '🚨 Critique';
                  return (
                    <tr key={it.id}>
                      <td style={s.td}>{it.nom}</td>
                      <td style={s.td}>{it.stock_actuel} {it.unite}</td>
                      <td style={s.td}>{it.seuil_actif} {it.unite}</td>
                      <td style={{ ...s.td, color, fontWeight:'bold' }}>{label}</td>
                      <td style={s.td}>{it.quantite_reappro ? `${it.quantite_reappro} ${it.unite}` : '—'}</td>
                      <td style={s.td}>{it.fournisseur || '—'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {stockStatus.items.length === 0 && (
              <div style={{ textAlign:'center', padding:'40px', color:'#aaa' }}>
                Aucun composant configuré.
              </div>
            )}
          </div>
        )}
        {tab === 'commandes' && <BonsCommandePanel s={s} />}

      </div>

      {editItem && (
        <div style={s.modal}>
          <div style={s.modalBox}>
            <h3 style={{ color:'#e94560', marginBottom:'20px' }}>✏️ Modifier — {editItem.composant_nom || editItem.composant_name}</h3>
            <label style={s.label}>Portions</label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              style={s.input}
              value={editItem.portions_produites}
              onChange={e => setEditItem({...editItem, portions_produites: e.target.value.replace(/[^0-9]/g, '')})}
              onBlur={e => { if (!e.target.value) setEditItem(i => ({...i, portions_produites: ''})); }}
            />
            <label style={s.label}>Mode de conservation</label>
            <select style={s.select} value={editItem.mode_conservation} onChange={e => setEditItem({...editItem, mode_conservation: e.target.value})}>
              <option value="frigo">❄️ Frigo</option>
              <option value="congelateur">🧊 Congélateur</option>
              <option value="ambiant">🌡️ Ambiant</option>
            </select>
            <label style={s.label}>Emplacement</label>
            <input style={s.input} value={editItem.emplacement || ''} onChange={e => setEditItem({...editItem, emplacement: e.target.value})} />
            <label style={s.label}>Notes</label>
            <input style={s.input} value={editItem.notes || ''} onChange={e => setEditItem({...editItem, notes: e.target.value})} />
            <div style={{ display:'flex', gap:'10px', marginTop:'10px' }}>
              <button style={s.btn} onClick={handleEdit}>Enregistrer</button>
              <button style={{...s.btn, background:'#333'}} onClick={() => setEditItem(null)}>Annuler</button>
            </div>
          </div>
        </div>
      )}

      {editComp && (
        <div style={s.modal}>
          <div style={s.modalBox}>
            <h3 style={{ color:'#e94560', marginBottom:'20px' }}>⚙️ Config — {editComp.nom}</h3>
            <label style={s.label}>Mode de conservation par défaut</label>
            <select style={s.select} value={editComp.mode_conservation} onChange={e => setEditComp({...editComp, mode_conservation: e.target.value})}>
              <option value="frigo">❄️ Frigo</option>
              <option value="congelateur">🧊 Congélateur</option>
              <option value="ambiant">🌡️ Ambiant</option>
            </select>
            <label style={s.label}>DLC frigo (jours)</label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              style={s.input}
              value={editComp.dlc_frigo_jours || ''}
              onChange={e => setEditComp({...editComp, dlc_frigo_jours: e.target.value.replace(/[^0-9]/g, '')})}
              placeholder="ex: 3"
            />
            <label style={s.label}>DLC congélateur (jours)</label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              style={s.input}
              value={editComp.dlc_congelateur_jours || ''}
              onChange={e => setEditComp({...editComp, dlc_congelateur_jours: e.target.value.replace(/[^0-9]/g, '')})}
              placeholder="ex: 30"
            />
            <label style={s.label}>Emplacement par défaut</label>
            <input style={s.input} value={editComp.emplacement_defaut || ''} onChange={e => setEditComp({...editComp, emplacement_defaut: e.target.value})} placeholder="ex: frigo 1, bac 3..." />
            <div style={{ display:'flex', gap:'10px', marginTop:'10px' }}>
              <button style={s.btn} onClick={handleSaveComp}>Enregistrer</button>
              <button style={{...s.btn, background:'#333'}} onClick={() => setEditComp(null)}>Annuler</button>
            </div>
          </div>
        </div>
      )}
    </div>
      {newComp && (
        <div style={s.modal}>
          <div style={s.modalBox} translate="no">
            <h3 style={{ color:'#e94560', marginBottom:'20px' }}>➕ Nouveau semi-fini</h3>
            <label style={s.label}>Nom</label>
            <input style={s.input} value={newComp.nom} onChange={e => setNewComp({...newComp, nom: e.target.value})} placeholder="ex: Purée maison" />
            <label style={s.label}>Unité</label>
            <select style={s.select} value={newComp.unite} onChange={e => setNewComp({...newComp, unite: e.target.value})}>
              <option value="portion">portion</option>
              <option value="L">L</option>
              <option value="kg">kg</option>
              <option value="g">g</option>
            </select>
            <label style={s.label}>Seuil alerte (quantité min avant d'en refaire)</label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              style={s.input}
              value={newComp.seuil_alerte}
              onChange={e => setNewComp({...newComp, seuil_alerte: e.target.value.replace(/[^0-9]/g, '')})}
              placeholder="ex: 3"
            />
            <div style={{ display:'flex', gap:'10px', marginTop:'10px' }}>
              <button style={s.btn} onClick={handleCreateComp}>Créer</button>
              <button style={{...s.btn, background:'#333'}} onClick={() => setNewComp(null)}>Annuler</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
